module.exports = __webpack_public_path__ + "static/img/animals3.f67830d1.jpg";